module.exports = __webpack_public_path__ + "media/images/sp/stores/suns/magazine/section03_04_beach-photo-c15b74602f85556657f85c49a732522d.jpg";